<template>
  <d-modal
    :active="isActive"
    :width="400"
    @close="handleClose"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <div class="p-6 text-center">
      <!-- Warning Icon -->
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
        <d-icon icon="exclamation-triangle" class="h-6 w-6 text-red-600" />
      </div>
      
      <!-- Title -->
      <h3 class="text-lg font-medium text-gray-900 mb-2">
        {{ title || 'Confirm Action' }}
      </h3>
      
      <!-- Message -->
      <div class="text-sm mb-6" v-html="message"></div>
      
      <!-- Actions -->
      <div class="flex gap-3 justify-center">
        <d-btn 
          flat
          @click="handleClose"
          :disabled="confirming"
        >
          Cancel
        </d-btn>
        <d-btn 
          color="error"
          :loading="confirming"
          @click="handleConfirm"
          :disabled="confirming"
        >
          {{ confirmText || 'Confirm' }}
        </d-btn>
      </div>
    </div>
  </d-modal>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Confirm Action',
    },
    message: {
      type: String,
      default: 'Are you sure you want to proceed?',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
  },
  emits: ['close', 'confirm'],
  
  data() {
    return {
      isActive: false,
      confirming: false,
    };
  },

  watch: {
    active: {
      immediate: true,
      handler(newValue) {
        this.isActive = newValue;
        if (!newValue) {
          this.confirming = false;
        }
      },
    },
  },

  methods: {
    async handleConfirm() {
      this.confirming = true;
      try {
        await this.$emit('confirm');
        this.handleClose();
      } catch (error) {
        console.error('Confirm action failed:', error);
      } finally {
        this.confirming = false;
      }
    },

    handleClose() {
      this.isActive = false;
      this.confirming = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
/* Removed duplicate modal styling to fix ghost outline issue */
</style>
